module.exports = __webpack_public_path__ + "img/case-logo-12.66220076.png";